import React from "react";

import { Location } from "../../../../../../models/location";
import useStyles from "./styles";

interface Props {
  location: Location;
}

const LocationRow = ({ location }: Props) => {
  const classes = useStyles();

  const renderTextLocation = (location?: Location) => {
    if (location && location?.longAddress) return location?.longAddress?.toString()?.trim() || "";

    if (location?.suburb) return `${location?.addressLine1}, ${location?.suburb}`.trim();

    return location?.addressLine1?.trim();
  };

  return (
    <div className={classes.locationDiv}>
      <div className="flex-location">
        <div className="div-location-ellipsis">
          <span>{renderTextLocation(location)}</span>
        </div>
      </div>
    </div>
  );
};

export default LocationRow;
